<template>
  <div id="upgradedusers_wrap">
    <headers />
    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">完善学校审核信息</div>
    </div>
    <div class="center_wrap">
      <div class="approve_msg">
        <div class="approve_state_one">
          <span class="approve_state_one_left">认证状态:</span>
          <span class="approve_state_one_right">{{renzheng_state}}</span>
        </div>
        <div class="approve_state_two">
          <span class="approve_state_one_left">认证信息:</span>
          <span class="approve_state_one_right">(注:请正确填写您的认证信息,以保证顺利通过认证。认证通过后,营业执照/身份证/护照信息不可修改。)</span>
        </div>
        <div class="upgradeuser">
          <div class="upgradeuser_form_wrap">
            <div class="pinpai_content">
              <i class="erro-text">*</i>学校名称</div>
            <div class="jigou_mingcheng_text">
              <el-input v-model="jigou_show_student" placeholder="请输入学校名称" class="jigou_mingcheng_text_in" :class="{'color_qiye_ones':color_qiye_one_stun}"></el-input>
            </div>
            <div class="number_erro" :class="{'colordisplay':errodisplay_inforstu}">
              <div class="number_erro_content">{{errodisplay_inforstus}}</div>
            </div>
            <!-- <div class="pinpai_content">品牌名称(非必填)</div>
            <div class="jigou_mingcheng_text">
              <el-input v-model="jigou_show" placeholder="请输入品牌名称" class="jigou_mingcheng_text_in" :class="{'color_qiye_one':color_qiye_one_stu}"></el-input>
            </div> -->
            <!-- <div class="number_erro" :class="{'colordisplay':errodisplay}">
              <div class="number_erro_content">{{jigou_content}}</div>
            </div> -->
            <!-- <div class="pinpai_content">品牌名称Logo</div>
            <div class="jigou_mingcheng_text">
              <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-error="erro_fun">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="logo_text_content">宽高要求必须是260px X 90px,大小不超过1MB</div> -->
            <div class="pinpai_leimu">
              <i class="erro-text">*</i>主营类目</div>
            <div class="pinpai_leimu_content">
              <el-select v-model="pinpai_leimu_content" placeholder="请选择" :class="{'colorerro_seven':colorerro_seven}">
                <el-option v-for="item in pinpai_leimu_data" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="pinpai_content_adress">
              <i class="erro-text">*</i>所在地址</div>
            <div class="pinpai_content_adress_content">
              <el-select v-model="city_view" placeholder="请选择国家" class="country_select" @change="country_change" :class="{'colorerro_three':colorerro_three}">
                <el-option v-for="item in  arrcitydata" :key="item.value" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
              <el-select v-model="chengshiview" placeholder="请选择省/直辖市" class="country_select" v-show="see_province" @change="city_end" :class="{'colorerro_four':colorerro_four}">
                <el-option v-for="item in  arrcitydatas" :key="item.value" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
              <el-select v-model="chengshiview_surplus" placeholder="请选择城市" class="country_select" v-show="see_province_surplus" :class="{'colorerro_six':colorerro_six}">
                <el-option v-for="item in  arrcitydatas_surplus" :key="item.value" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </div>
            <!-- <div class="pinpai_content">
              <i class="erro-text">*</i>详细地址</div>
            <div class="jigou_mingcheng_text">
              <el-input v-model="adress_show" placeholder="请输入详细地址" class="jigou_mingcheng_text_in" :class="{'colorerro_q':colorerro_q}"></el-input>
            </div>
            <div class="number_erro" :class="{'colordisplay_address':colordisplay_addres}">
              <div class="number_erro_content">{{minute_address}}</div>
            </div> -->
            <div class="pinpai_content">学校网址</div>
            <div class="jigou_mingcheng_text">
              <el-input v-model="school_show" placeholder="(选填)" class="jigou_mingcheng_text_in" :class="{'color_qiye_web':color_qiye_web}"></el-input>
            </div>
            <div class="number_erro" :class="{'colordisplay_web':errodisplay_web}">
              <div class="number_erro_content">{{school_web}}</div>
            </div>
            <!-- <div class="pinpai_content">
              <i class="erro-text">*</i>负责人姓名</div>
            <div class="jigou_mingcheng_text">
              <el-input v-model="fuze_name" placeholder="请输入负责人姓名" class="jigou_mingcheng_text_in" :class="{'colorerro_eight':colorerro_eight}"></el-input>
            </div>
            <div class="number_erro" :class="{'colorerro_nine':colorerro_nine}">
              <div class="number_erro_content">{{fuze_people}}</div>
            </div>
            <div class="pinpai_content">
              <i class="erro-text">*</i>负责人电话</div>
            <div class="jigou_mingcheng_text">
              <el-input v-model="fuze_phone" readonly="readonly" placeholder="请输入负责人电话" class="jigou_mingcheng_text_in" :class="{'colorerro_ten':colorerro_ten}"></el-input>
            </div>
            <div class="number_erro" :class="{'colorerro_ele':colorerro_ele}">
              <div class="number_erro_content">{{fuze_number}}</div>
            </div> -->
            <div class="pinpai_content">
              <i class="erro-text">*</i>邮箱</div>
            <div class="jigou_mingcheng_text">
              <el-input v-model="fuze_email" placeholder="请输入邮箱" class="jigou_mingcheng_text_in" :class="{'colorerro_email':colorerro_email}"></el-input>
            </div>
            <div class="number_erro" :class="{'colorerro_email_erro':colorerro_email_erro}">
              <div class="number_erro_content">{{email_erro}}</div>
            </div>
            <div class="pinpai_content">营业执照信息
              <span class="span_erro">{{sprans}}</span>
            </div>
            <div class="business_license">
              <div class="agree_tiaoyue_btn">
                <el-checkbox v-model="checkeds"></el-checkbox>
              </div>
              <div class="agree_tiaoyue_text">我暂时没有营业执照</div>
            </div>
            <div class="license_one" v-show="!checkeds">
              <div class="pinpai_content">
                <i class="erro-text">*</i>法定代表人</div>
              <div class="jigou_mingcheng_text">
                <el-input v-model="law_name" placeholder="请输入法定代表人姓名" class="jigou_mingcheng_text_in" :class="{'colorerro_low':colorerro_low}"></el-input>
              </div>
              <div class="number_erro" :class="{'colorerro_people_law':colorerro_people_law}">
                <div class="number_erro_content">{{pepple_law}}</div>
              </div>
              <div class="pinpai_content">营业执照</div>
              <div class="jigou_mingcheng_text">
                <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess_two" :before-upload="beforeAvatarUpload_two" :on-error="erro_funs">
                  <img v-if="imageUrls" :src="imageUrls" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="logo_text_content">请上传营业执照(统一社会信用代码证等)照片,照片务必清晰完整。图片格式支持JPG,PNG,图片大小不超过2MB</div>
              <div class="pinpai_content newpinpai_content">
                <i class="erro-text">*</i>统一社会信用代码:</div>
              <div class="jigou_mingcheng_text">
                <el-input v-model="law_name_code" placeholder="请填写上传证书的编号" class="jigou_mingcheng_text_in" :class="{'colorerro_low_code':colorerro_low_code}"></el-input>
              </div>
              <div class="number_erro" :class="{'colorerro_code':colorerro_code}">
                <div class="number_erro_content">{{corlor_code_inner}}</div>
              </div>
            </div>
            <div class="license_two" v-show="checkeds">
              <div class="pinpai_content">
                <i class="erro-text">*</i>身份类型</div>
              <div class="pinpai_leimu_content">
                <el-select v-model="id_card" placeholder="请选择" :class="{'colorerro_shenfen_code':colorerro_shenfen_code}">
                  <el-option v-for="item in iddatas" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="pinpai_content">
                <i class="erro-text">*</i>证件姓名</div>
              <div class="jigou_mingcheng_text">
                <el-input v-model="shenfen_name" placeholder="请输入证件上的姓名" class="jigou_mingcheng_text_in" :class="{'colorerro_shenfen_name':colorerro_shenfen_name}"></el-input>
              </div>
              <div class="number_erro" :class="{'colorerro_code_name':colorerro_code_name}">
                <div class="number_erro_content">{{corlor_code_inner_code}}</div>
              </div>
              <div class="pinpai_content">证件照片</div>
              <div class="jigou_mingcheng_text">
                <imgCut @imgChangeUrl="logourlthree=$event" :imageUrl="logourlthree" v-if='identity_tset==1'></imgCut>
              </div>
              <div class="logo_text_content">请上传手持证件照的半身照,人脸和证件照信息务必清晰完整,并且露出完整手臂,图片格式支持JPG,PNG,图片大小不超过2MB。</div>
              <div class="pinpai_content">
                <i class="erro-text">*</i>证件号</div>
              <div class="jigou_mingcheng_text">
                <el-input v-model="shenfen_id_code" placeholder="请输入身份证或护照号码" class="jigou_mingcheng_text_in" :class="{'colorerro_shenfen_name_code':colorerro_shenfen_name_code}"></el-input>
              </div>
              <div class="number_erro" :class="{'colorerro_code_name_code':colorerro_code_name_code}">
                <div class="number_erro_content">{{corlor_code_inner_code_inner}}</div>
              </div>
            </div>
            <div class="login_susses">
              <el-button type="success" @click="go_enter()">确定</el-button>
              <el-button type="danger" @click="blank_to">返回</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footers />
  </div>
</template>
<script>
import headers from "./header.vue";
import imgCut from "./ImgCropper.vue";
import footers from "./footers.vue";
import Net_Work from "../apis/network.js";
import Address from "../apis/address.js";
import axios from "axios";
import _ from "lodash";
import Qs from "qs";
axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;
export default {
  name: "upgradedusers",
  data() {
    return {
      img3: "",
      identity_tset: "",
      approve_msg: "未认证",
      colorerro_shenfen_name: false,
      loading1: "",
      loading2: "",
      loading3: "",
      renzheng_state: "未认证",
      color_qiye_one_stu: false,
      color_qiye_one_stun: false,
      sprans: "",
      jigou_show_student: "",
      colorerro_code_name_code: true,
      errodisplay_inforstu: true,
      colorerro_shenfen_code: false,
      corlor_code_inner_code: "请输入内容",
      corlor_code_inner_code_inner: "请输入内容",
      errodisplay_inforstus: "学校内容不能为空",
      colorerro_code_name: true,
      uploadUrl: "/f/api/v3",
      colorerro_shenfen_name_code: false,
      colorerro_people_law: true,
      colorerro_code: true,
      colorerro_low: false,
      colordisplay_addres: true,
      pepple_law: "",
      colorerro_ten: false,
      colorerro_eight: false,
      corlor_code_inner: "请输入内容",
      fuze_number: "不能超过20个字符",
      email_erro: "邮箱格式错误",
      fuze_people: "",
      colorerro_nine: true,
      colorerro_low_code: false,
      colorerro_ele: true,
      color_qiye_web: false,
      colorerro_email: false,
      colorerro_email_erro: true,
      errodisplay_web: true,
      school_web: "",
      colorerro_q: false,
      minute_address: "",
      colorerro_six: false,
      errodisplay: true,
      law_name_code: "",
      id_card: "",
      law_name: "",
      color_qiye_one: false,
      colorerro_seven: false,
      imageUrls: "",
      jigou_content: "请输入内容",
      fuze_phone: "",
      imagethree: "",
      fuze_name: "",
      fuze_phone: "",
      shenfen_id_code: "",
      shenfen_name: "",
      checkeds: false,
      iddatas: [
        {
          value: "身份证",
          label: "身份证"
        },
        {
          value: "护照",
          label: "护照"
        }
      ],
      fuze_email: "",
      pinpai_leimu_content: "",
      pinpai_leimu_data: Address.pinpai_leimu_datas,
      arrcitydata: Address.arrcity,
      input_content: "",
      chengshiview_surplus: "",
      colorerro_three: false,
      see_province: false,
      see_province_surplus: false,
      colorerro_four: false,
      city_view: "",
      chengshiview: "",
      jigou_show: "",
      arrcitydatas: "",
      arrcitydatas_surplus: "",
      imageUrl: "",
      new_filse: "",
      acctoken: "",
      school_show: "",
      adress_show: "",
      logourl: "",
      linse_one: "",
      linsenuril: "",
      linsenimg: "",
      logourlthree: ""
    };
  },
  methods: {
    blank_to() {
      location.replace(Net_Work.publicPhoneAddress);
    },
    handleAvatarSuccess(res, file) {
      this.loading1.close();
      this.$message.success("上传成功");
      this.linsenuril = res.url;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    erro_fun(err, file, fileList) {
      this.$message.error("上传失败");
    },
    beforeAvatarUpload(file) {
      var _this = this;
      this.new_filse = file;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      return new Promise(function(resolve, reject) {
        reader.onload = function(event) {
          var txt = event.target.result;
          var img = document.createElement("img");
          var isJPG = _this.new_filse.type === "image/jpeg";
          var isPNG = _this.new_filse.type === "image/png";
          var picture_on = true;
          var isLt2M = _this.new_filse.size / 1024 / 1024 < 1;
          var _img_width;
          var _img_height;
          var iswidth;
          var isheight;
          var img_on = false;
          img.src = txt;
          if (!isJPG) {
            if (!isPNG) {
              _this.$message.error("上传图片只能是 JPG 格式或者 PNG 格式!");
              picture_on = false;
              return reject();
            } else {
              picture_on = true;
            }
          }
          if (!isLt2M) {
            _this.$message.error("上传头像图片大小不能超过 1MB!");
            return reject();
          }
          img.onload = function() {
            _img_width = img.width; /*图片宽度*/
            _img_height = img.height; /*图片高度*/
            if (_img_width == 260) {
              if (_img_height == 90) {
                img_on = true; /*图片大小格式正确*/
              } else {
                _this.$message.error("上传头像图片宽高必须是 260px X 90px");
                img_on = false;
                return reject();
              }
            } else {
              _this.$message.error("上传头像图片宽高必须是 260px X 90px");
              img_on = false; /*图片大小格式错误*/
              return reject();
            }
            if (picture_on && isLt2M && img_on) {
              _this.loading1 = _this.$loading({
                lock: true,
                text: "图片上传中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
              });
              resolve(true);
            } else {
              return reject();
            }
          };
        };
      });
    },
    country_change() {
      var couert_data = this.city_view;
      function findCherries(fruit) {
        return fruit.name === couert_data;
      }
      var this_arrshengfen_data = this.arrcitydata.find(findCherries);

      var test_shengfen = this_arrshengfen_data.hasOwnProperty("state");

      if (test_shengfen) {
        this.see_province = true;
        this.chengshiview = "";
        if (Array.isArray(this_arrshengfen_data.state)) {
          this.arrcitydatas = "";
          this.chengshiview = "";
          this.see_province_surplus = false;
          this.arrcitydatas = this_arrshengfen_data.state;
        } else if (this_arrshengfen_data.state instanceof Object) {
          this.arrcitydatas_surplus = "";
          this.see_province = false;
          this.chengshiview_surplus = "";
          this.see_province_surplus = true;
          this.arrcitydatas_surplus = this_arrshengfen_data.state.city;
        }
      } else {
        this.chengshiview = "";
        this.chengshiview_surplus = "";
        this.see_province = false;
        this.see_province_surplus = false;
      }
    },
    city_end() {
      var couert_end_data = this.chengshiview;

      function findCherries(fruit) {
        return fruit.name === couert_end_data;
      }
      this.arrcitydatas_surplus = "";
      this.chengshiview_surplus = "";
      var this_arrshengfen_data = this.arrcitydatas.find(findCherries);

      var test_city = this_arrshengfen_data.hasOwnProperty("city");
      if (test_city) {
        this.see_province_surplus = true;
        this.arrcitydatas_surplus = this_arrshengfen_data.city;
      } else {
        this.arrcitydatas_surplus = "";
        this.chengshiview_surplus = "";
        this.see_province_surplus = false;
      }
    },
    beforeAvatarUpload_two(file) {
      const isJPG = file.type === "image/jpeg";
      var isPNG = file.type === "image/png";
      var picture_on = true;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        if (!isPNG) {
          this.$message.error("上传图片只能是 JPG 格式或者 PNG 格式!");
          picture_on = false;
        } else {
          picture_on = true;
        }
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      if (isLt2M && picture_on) {
        this.loading2 = this.$loading({
          lock: true,
          text: "图片上传中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
      }
      return isLt2M && picture_on;
    },
    handleAvatarSuccess_two(res, file) {
      this.loading2.close();
      this.$message.success("上传成功");
      this.logourls = res.url;
      this.imageUrls = URL.createObjectURL(file.raw);
    },
    erro_funs(err, file, fileList) {
      this.$message.error("上传失败");
    },
    go_enter: _.throttle(function() {
      var _pin01 = true;
      var _pin02 = true;
      var _leimu = false;
      var _stundenname = false;
      var _email = true;
      var _law_people = false;
      var _this = _this;
      var _people = false;
      var _principal = true;
      var _guojia = false;
      var _shengfen = false;
      var _address = false;
      var _law_people_shenfen = false;
      var _shenfenzhengcode = false;
      var _password = false;
      var _city = false;
      if (!this.jigou_show_student) {
        this.color_qiye_one_stun = true;
        this.errodisplay_inforstu = false;
        this.errodisplay_inforstus = "请输入学校名称";
      } else {
        if (this.jigou_show_student.length > 30) {
          this.color_qiye_one_stun = true;
          this.errodisplay_inforstu = false;
          this.errodisplay_inforstu = "内容长度不超过30个字符";
        } else {
          this.color_qiye_one_stun = false;
          this.errodisplay_inforstu = true;
          _stundenname = true;
        }
      }
      if (_stundenname) {
        _pin01 = true;
      }
      if (_pin01 && _stundenname) {
        if (!this.pinpai_leimu_content) {
          this.colorerro_seven = true;
        } else {
          this.colorerro_seven = false;
          _leimu = true;
        }
      }
      if (_pin01 && _leimu) {
        if (!this.city_view) {
          this.colorerro_three = true;
        } else {
          this.colorerro_three = false;
          _guojia = true;
        }
      }
      if (_pin01 && _leimu && _guojia) {
        if (!this.chengshiview) {
          if (this.see_province === false) {
            _shengfen = true;
          } else {
            this.colorerro_four = true;
          }
        } else {
          this.colorerro_four = false;
          _shengfen = true;
        }
      }
      if (_pin01 && _leimu && _guojia && _shengfen) {
        if (!this.chengshiview_surplus) {
          if (this.see_province_surplus === false) {
            this.colorerro_six = false;
            _city = true;
          } else {
            this.colorerro_six = true;
          }
        } else {
          this.colorerro_six = false;
          _city = true;
        }
      }
      if (_pin01 && _leimu && _guojia && _shengfen && _city) {
        _address = true;
      }
      if (_pin01 && _leimu && _guojia && _shengfen && _city && _address) {
        if (!this.school_show) {
          _pin02 = true;
          this.color_qiye_web = false;
          this.errodisplay_web = true;
        } else {
          if (this.school_show.length > 200) {
            _pin02 = false;
            this.jigou_content = "内容长度不超过200个字符";
            this.color_qiye_web = true;
            this.errodisplay_web = false;
          } else {
            _pin02 = true;
            this.color_qiye_web = false;
            this.errodisplay_web = true;
          }
        }
      }
      // if (
      //   _pin01 &&
      //   _leimu &&
      //   _guojia &&
      //   _shengfen &&
      //   _city &&
      //   _address &&
      //   _pin02
      // ) {
      //   if (!this.fuze_name) {
      //     this.colorerro_nine = false;
      //     this.colorerro_eight = true;
      //     this.fuze_people = "请输入姓名";
      //   } else if (this.fuze_name.length > 10) {
      //     this.colorerro_nine = false;
      //     this.colorerro_eight = true;
      //     this.fuze_people = "长度不能超过10个字符";
      //   } else {
      //     this.colorerro_nine = true;
      //     _principal = true;
      //     this.colorerro_eight = false;
      //   }
      // }
      // if (
      //   _pin01 &&
      //   _leimu &&
      //   _guojia &&
      //   _shengfen &&
      //   _city &&
      //   _address &&
      //   _pin02 &&
      //   _principal
      // ) {
      //   // var _rexp5 = /^[0-9]{1,11}$/;
      //   //alert(this.fuze_phone.length)
      //   if (this.fuze_phone.length <= 20) {
      //     this.colorerro_ten = false;
      //     this.colorerro_ele = true;
      //     _email = true;
      //   } else {
      //     this.colorerro_ten = true;
      //     this.colorerro_ele = false;
      //   }
      // }
      if (
        _pin01 &&
        _leimu &&
        _guojia &&
        _shengfen &&
        _city &&
        _address &&
        _pin02 &&
        _principal &&
        _email
      ) {
        var rexp_email = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
        if (rexp_email.test(this.fuze_email)) {
          this.colorerro_email = false;
          this.colorerro_email_erro = true;
          _password = true;
        } else {
          this.colorerro_email = true;
          this.colorerro_email_erro = false;
        }
      }
      if (
        _pin01 &&
        _leimu &&
        _guojia &&
        _shengfen &&
        _city &&
        _address &&
        _pin02 &&
        _principal &&
        _email &&
        _password
      ) {
        if (this.checkeds === false) {
          if (!this.law_name) {
            this.colorerro_low = true;
            this.colorerro_people_law = false;
            this.pepple_law = "请输入姓名";
          } else if (this.law_name.length > 10) {
            this.colorerro_low = true;
            this.colorerro_people_law = false;
            this.pepple_law = "长度不能超过10个字符";
          } else {
            this.colorerro_low = false;
            this.colorerro_people_law = true;
            _law_people = true;
            if (
              _pin01 &&
              _leimu &&
              _guojia &&
              _shengfen &&
              _city &&
              _address &&
              _pin02 &&
              _principal &&
              _email &&
              _password &&
              _law_people
            ) {
              if (!this.law_name_code) {
                this.colorerro_low_code = true;
                this.colorerro_code = false;
              } else {
                if (this.law_name_code.length > 30) {
                  this.corlor_code_inner = "内容长度不超过30个字符";
                  this.colorerro_low_code = true;
                  this.colorerro_code = false;
                } else {
                  this.colorerro_low_code = false;

                  this.colorerro_code = true;
                  /*可以发送网络请求了 */
                  if (!this.checkeds) {
                    var isbussinessLicenseFlag = 1;
                  } else {
                    isbussinessLicenseFlag = 0;
                  }
                  axios.defaults.headers.common[
                    "Authorization"
                  ] = this.acctoken;
                  axios
                    .post(
                      "/s/api/school/user/upgrade/school" /*最新代码位置*/,
                      Qs.stringify({
                        brandName: this.jigou_show,
                        schoolName: this.jigou_show_student,
                        mainCategories: this.pinpai_leimu_content,
                        country: this.city_view,
                        province: this.chengshiview,
                        city: this.chengshiview_surplus,
                        detailedAddress: "",
                        website: this.school_show,
                        brandLogo: this.linsenuril,
                        bussinessLicenseFlag: isbussinessLicenseFlag,
                        legalRepresentative: this.law_name,
                        bussinessLicense: this.logourls,
                        unifiedSocialCreditCode: this.law_name_code,
                        identityType: this.id_card,
                        identityName: this.shenfen_name,
                        identityPhoto: this.logourlthree,
                        identityNumber: this.shenfen_id_code,
                        //chargePerson: this.fuze_name,
                        //chargePersonPhone: this.fuze_phone,
                        mailbox: this.fuze_email
                      })
                    )
                    .then(response => {
                      if (response.data.code == 0) {
                        var _this = this;
                        this.$message({
                          showClose: true,
                          message: response.data.msg,
                          duration: 1000,
                          type: "success",
                          onClose() {
                            _this.$router.push("/backstage");
                          }
                        });
                      } else {
                        this.$message({
                          showClose: true,
                          message: response.data.msg,
                          type: "error"
                        });
                      }
                    })
                    .catch(function(error) {});
                }
              }
            }
          }
        } else {
          if (!this.id_card) {
            this.colorerro_shenfen_code = true;
          } else {
            this.colorerro_shenfen_code = false;
            _shenfenzhengcode = true;
            if (
              _pin01 &&
              _leimu &&
              _guojia &&
              _shengfen &&
              _city &&
              _address &&
              _pin02 &&
              _principal &&
              _email &&
              _shenfenzhengcode
            ) {
              if (!this.shenfen_name) {
                this.colorerro_shenfen_name = true;
                this.colorerro_code_name = false;
              } else if (this.shenfen_name.length > 10) {
                this.colorerro_shenfen_name = true;
                this.colorerro_code_name = false;
                this.corlor_code_inner_code = "长度不能超过10个字符";
              } else {
                this.colorerro_shenfen_name = false;
                this.colorerro_code_name = true;
                _law_people_shenfen = true;

                if (
                  _pin01 &&
                  _leimu &&
                  _guojia &&
                  _shengfen &&
                  _city &&
                  _address &&
                  _pin02 &&
                  _principal &&
                  _email &&
                  _shenfenzhengcode &&
                  _law_people_shenfen
                ) {
                  if (!this.shenfen_id_code) {
                    this.colorerro_shenfen_name_code = true;
                    this.colorerro_code_name_code = false;
                  } else if (this.shenfen_id_code.length > 30) {
                    this.colorerro_shenfen_name_code = true;
                    this.colorerro_code_name_code = false;
                    this.corlor_code_inner_code_inner = "长度不能超过30个字符";
                  } else {
                    this.colorerro_shenfen_name_code = false;
                    this.colorerro_code_name_code = true;
                    if (!this.checkeds) {
                      var isbussinessLicenseFlag = 1;
                    } else {
                      isbussinessLicenseFlag = 0;
                    }
                    var _this = this;
                    axios.defaults.headers.common[
                      "Authorization"
                    ] = this.acctoken;
                    axios
                      .post(
                        "/s/api/school/user/upgrade/school" /*最新代码位置*/,
                        Qs.stringify({
                          brandName: this.jigou_show,
                          schoolName: this.jigou_show_student,
                          mainCategories: this.pinpai_leimu_content,
                          country: this.city_view,
                          province: this.chengshiview,
                          city: this.chengshiview_surplus,
                          detailedAddress: this.adress_show,
                          website: this.school_show,
                          brandLogo: this.linsenuril,
                          bussinessLicenseFlag: isbussinessLicenseFlag,
                          legalRepresentative: this.law_name,
                          bussinessLicense: this.logourls,
                          unifiedSocialCreditCode: this.law_name_code,
                          identityType: this.id_card,
                          identityName: this.shenfen_name,
                          identityPhoto: this.logourlthree,
                          identityNumber: this.shenfen_id_code,
                          chargePerson: this.fuze_name,
                          chargePersonPhone: this.fuze_phone,
                          mailbox: this.fuze_email
                        })
                      )
                      .then(response => {
                        if (response.data.code == 0) {
                          this.$message({
                            showClose: true,
                            message: response.data.msg,
                            duration: 1000,
                            type: "success",
                            onClose() {
                              _this.$router.push("/backstage");
                            }
                          });
                        } else {
                          this.$message({
                            showClose: true,
                            message: response.data.msg,
                            type: "error"
                          });
                        }
                      })
                      .catch(function(error) {});
                  }
                }
              }
            }
          }
        }
      }
    }, 2000)
  },
  components: {
    headers,
    footers,
    imgCut
  },
  created() {
    var _this = this;
    var _daclass = localStorage.getItem("dbclass-spa");
    if (!_daclass) {
      this.$router.push("/password-login");
    } else {
      _daclass = JSON.parse(_daclass);
      this.acctoken = _daclass.token.access_token;
    }
    if (this.acctoken === "") {
      this.$router.push("/password-login");
    }
    this.uploadUrl =
      Net_Work.publicApi + this.uploadUrl + "?access_token=" + this.acctoken;
    axios.defaults.headers.common["Authorization"] = this.acctoken;
    // Make a request for a user with a given ID
    axios
      .get("/s/api/school/get/user/school")
      .then(function(response) {
        if (response.data.code === 0) {
          if (response.data.hasOwnProperty("data")) {
            if (response.data.data.auditStatus === 0) {
              _this.renzheng_state = "待审核";
            } else if (response.data.data.auditStatus === 1) {
              _this.renzheng_state = "已通过";
              _this.sprans = `(审核通过后,以下信息不能更改)`;
            } else {
              _this.renzheng_state = `已驳回(${
                response.data.data.failureReasons
              })`;
            }
            _this.jigou_show = response.data.data.brandName;
            _this.jigou_show_student = response.data.data.schoolName;
            _this.pinpai_leimu_content = response.data.data.mainCategories;

            if (response.data.data.province === "") {
              var couert_data = response.data.data.country;
              var this_arrshengfen_data = _this.arrcitydata.find(ele => {
                return ele.name == couert_data;
              });
              if (this_arrshengfen_data.state instanceof Object) {
                _this.arrcitydatas_surplus = this_arrshengfen_data.state.city;
              }
              /*市级联动BUG修改 */
            } else {
              _this.see_province = true;
              var couert_data = response.data.data.country;
              var this_arrshengfen_data = _this.arrcitydata.find(ele => {
                return ele.name == couert_data;
              });
              var test_shengfen = this_arrshengfen_data.hasOwnProperty("state");
              _this.arrcitydatas = this_arrshengfen_data.state;
            }
            _this.city_view = response.data.data.country;
            _this.chengshiview = response.data.data.province;
            if (response.data.data.city === "") {
              _this.see_province_surplus = false;
            } else {
              _this.see_province_surplus = true;
              if (response.data.data.province === "") {
                var couert_data = response.data.data.country;
                var this_arrshengfen_data = _this.arrcitydata.find(ele => {
                  return ele.name == couert_data;
                });
                if (this_arrshengfen_data.state instanceof Object) {
                  _this.arrcitydatas_surplus = this_arrshengfen_data.state.city;
                }
              } else {
                var couert_end_datas = response.data.data.province;

                function findCherries(fruit) {
                  return fruit.name === couert_end_datas;
                }
                var this_arrshengfen_datas = _this.arrcitydatas.find(
                  findCherries
                );
                _this.arrcitydatas_surplus = this_arrshengfen_datas.city;
              }
            }
            _this.chengshiview_surplus = response.data.data.city;
            _this.adress_show = response.data.data.detailedAddress;
            _this.imageUrl = response.data.data.brandLogo;
            if (response.data.data.brandLogo === "") {
              _this.linsenuril = "";
            } else {
              _this.linsenuril = response.data.data.brandLogo;
            }

            // 1:企业 不打勾
            // 0:个人 打勾
            // null: 不打勾
            if (response.data.data.businessLicenseFlag === 0) {
              _this.checkeds = true;
            } else {
              _this.checkeds = false;
            }
            
            if (response.data.data.businessLicense === "") {
              _this.logourls = "";
            } else {
              _this.logourls = response.data.data.businessLicense;
            }
            _this.law_name = response.data.data.legalRepresentative;
            _this.imageUrls = response.data.data.businessLicense;

            _this.law_name_code = response.data.data.unifiedSocialCreditCode;
            _this.id_card = response.data.data.identityType;
            _this.school_show = response.data.data.website;
            _this.shenfen_name = response.data.data.identityName;
            if (!response.data.data.identityPhoto) {
              _this.logourlthree = "";
              _this.identity_tset = 1;
            } else {
              _this.logourlthree = response.data.data.identityPhoto;
              _this.identity_tset = 1;
            }
            // _this.logourlthree = response.data.data.identityPhoto; /*3-22*/

            _this.shenfen_id_code = response.data.data.identityNumber;
            _this.fuze_name = response.data.data.chargePerson;
            _this.fuze_phone = response.data.data.chargePersonPhone;
            _this.fuze_email = response.data.data.mailbox;
          } else {
            _this.identity_tset = 1;
          }
        } else if (response.data.code === 401) {
          _this.$message({
            showClose: true,
            message: response.data.msg,
            duration: 1000,
            showClose: false,
            type: "error",
            onClose: () => {
              window.scrollTo(0, 0);
              _this.$router.push("/password-login");
            }
          });
        } else {
        }
      })
      .catch(function(error) {
        // handle error
      });
  }
};
</script>
<style lang="less" scoped>
.erro-text {
  color: #f56c6c;
  font-size: 12px;
  margin-right: 4px;
  padding-top: 3px;
}
#upgradedusers_wrap {
  #login_wrap_denglu {
    width: 100%;
    height: 155px;
    overflow: hidden;
    background-color: #eee;
    text-align: center;

    .login_wrap_denglu_top {
      font-family: " MicrosoftYaHei";
      font-size: 30px;
      color: #222743;
      margin-top: 45px;
    line-height: 52px;
    letter-spacing: 1px;
    }
  }

  .center_wrap {
    display: flex;
    justify-content: center;
  }

  .approve_msg {
    display: block;
    width: fit-content;

    .approve_state_one_left {
      font-size: 12px;
      font-weight: 900;
      margin-right: 24px;
    }

    .approve_state_one_right {
      font-size: 12px;
    }
  }

  .approve_state_two {
    .approve_state_one_right {
      color: #f56c6c;
    }
  }
}

.upgradeuser {
  width: 100%;
  padding-bottom: 80px;

  .upgradeuser_form_wrap {
    width: 320px;
    height: auto;
    margin-top: 16px;

    // border: 1px solid red;
    .pinpai_content {
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #999999;
      margin-top: 20px;
      line-height: 20px;
      display: flex;
      align-items: center;
    }

    .jigou_mingcheng_text {
      width: 260px;
      margin-top: 10px;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 260px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    border: 1px dashed #c7c7cc;
  }

  .avatar {
    width: 260px;
    height: 90px;
    display: block;
  }

  .logo_text_content {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    // color: #999999;
    margin-top: 5px;
    color: #f56c6c;
  }

  .pinpai_leimu {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
  }

  .pinpai_content_adress {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
  }

  .pinpai_leimu_content {
    width: 260px;
    margin-top: 10px;
  }

  .country_select {
    width: auto;
    margin-bottom: 8px;
  }

  .pinpai_content_adress_content {
    margin-top: 20px;
  }

  .business_license {
    display: flex;
    margin-top: 10px;

    .agree_tiaoyue_text {
      line-height: 32px;
      font-size: 12px;
      margin-left: 10px;
    }
  }

  .license_one {
    .pinpai_content {
      margin-top: 10px;
    }
  }

  .newpinpai_content {
    margin-top: 20px !important;
  }

  .license_two {
    .pinpai_content {
      margin-top: 10px !important;
    }
  }

  .login_susses {
    display: flex;
  }

  .login_susses {
    margin-top: 20px;

    .el-button {
      width: 60px;
      font-size: 12px;
      border-radius: 0px;
      height: 24px;
      line-height: 24px;
      padding: 0;
    }
  }

  .number_erro {
    display: flex;
    margin-top: 3px;

    .number_erro_content {
      width: 170px;
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";

      /**/
    }
  }

  .colordisplay {
    visibility: hidden;
  }

  .colordisplay_address {
    visibility: hidden;
  }

  .colordisplay_web {
    visibility: hidden;
  }

  .colorerro_nine {
    visibility: hidden;
  }

  .colorerro_code {
    visibility: hidden;
  }

  .colorerro_ele {
    visibility: hidden;
  }

  .colorerro_email_erro {
    visibility: hidden;
  }

  .colorerro_people_law {
    visibility: hidden;
  }

  .colorerro_code_name {
    visibility: hidden;
  }

  .colorerro_code_name_code {
    visibility: hidden;
  }

  .span_erro {
    color: #f56c6c;
    margin-left: 10px;
  }
}
</style>
<style lang="less">
.upgradeuser_form_wrap {
  .el-input__inner {
    padding: 0;
    margin: 0;
    padding-left: 11px;
    border-radius: 3px;
    height: 30px;
  }

  .el-input__suffix {
    right: -2px;
  }

  .el-input__icon {
    line-height: 30px;
  }

  .color_qiye_one {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_seven {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_three {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_four {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_six {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_q {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .color_qiye_web {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_eight {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_ten {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_email {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_low {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_low_code {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_shenfen_code {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_shenfen_name {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_shenfen_name_code {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .color_qiye_ones {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upgradedusers.vue